import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { floatPercentFromDTO } from 'utils/number'
import { BiddersForTable } from '../../../types'
import { SortBy } from '../types'
import { BiddersForTableDTO, SortByDTO } from './types'

export const fromDTO = (from: BiddersForTableDTO) =>
  mapDTO<BiddersForTableDTO, BiddersForTable>({ from }).transform(dto => {
    const {
      bidCpmAdjustment,
      bidder: { name },
      bidderCode,
      status,
      supplyChain,
    } = dto

    return {
      ...dto,
      bidCpmAdjustment: floatPercentFromDTO(bidCpmAdjustment),
      code: bidderCode,
      name,
      status,
      supplyChain: supplyChain ?? undefined,
    }
  })

export const sortToDTO = (sort: SortInput<SortBy>): SortInput<SortByDTO> => {
  const { by } = sort

  switch (by) {
    case 'code':
      return { ...sort, by: 'bidderCode' }
    case 'name':
      return { ...sort, by: 'bidderName' }
    default:
      return { ...sort, by }
  }
}
